module.exports = __webpack_public_path__ + "img/gift4-01-c09-t2.76e4735d.png";